import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LogInButtons from 'flarum/forum/components/LogInButtons';
/**
 * Adds a hint under fof/oauth's Disqus button, and an "or" separator between the provider buttons and core's
 * log in and sign up fields. Both modals render LogInButtons above their fields.
 */
export default function extendLogInButtons() {
  extend(LogInButtons.prototype, 'items', function (items) {
    // fof/oauth's items are added first, as it is a dependency: an empty list means no providers are on.
    if (items.isEmpty()) return;
    const onlyIcons = app.forum.attribute('fof-oauth.only_icons');

    // fof/oauth gives every provider the same priority, so the hint shares the Disqus item to stay right under it.
    // The icon-only layout is a row of round buttons with no room for text.
    if (items.has('disqus') && !onlyIcons) {
      items.setContent('disqus', [items.get('disqus'), m("p", {
        className: "LogInButtons-disqusHint"
      }, app.translator.trans('batmannews-oauth-disqus.forum.log_in.disqus_hint'))]);
    }

    // fof/oauth's OAuth-only mode removes the fields for everyone but admins, so there is nothing to separate.
    if (!app.forum.attribute('fofOauthOnly')) {
      items.add('separator', m("div", {
        className: "LogInButtons-separator"
      }, app.translator.trans('batmannews-oauth-disqus.forum.log_in.or_text')), -100);
    }
  });
}